import React, { useEffect, useState } from 'react';
import { Input, Icon } from 'components';
import { useDebounce } from 'hooks';
import styled from 'styled-components';
import { useLockboxesContext } from './LockboxesContext';

type SearchBarProps = {
  disabled?: boolean;
};

const SearchBar: React.FC<SearchBarProps> = ({ disabled }) => {
  const { text, setText, setPage } = useLockboxesContext();
  const [localText, setLocalText] = useState(text);
  const debouncedText = useDebounce(localText, 500);

  useEffect(() => {
    setText(debouncedText);
    setPage(1);
  }, [debouncedText]);

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalText(e.target.value);
  };
  return (
    <StyledInput
      disabled={disabled}
      allowClear
      placeholder={'Search lockboxes'}
      prefix={<Icon type="search" color="gray7" />}
      value={localText}
      onChange={onChangeHandler}
      data-cy={`lockboxes-brokerage-search`}
    />
  );
};

const StyledInput = styled(Input)`
  width: 280px;
  height: 50px;
  display: flex;
  align-items: center;
  & > span {
    height: 40px;
  }
`;

export default SearchBar;
